/**
 * An ObjectWidget wrapped in a collapsible accordion, so a group of
 * sub-fields can live inside the default fieldset of an InlineForm.
 */

import React, { useState } from 'react';
import { Accordion, Segment } from 'semantic-ui-react';
import AnimateHeight from 'react-animate-height';
import { Icon } from '@plone/volto/components';
import ObjectWidget from '@plone/volto/components/manage/Widgets/ObjectWidget';
import upSVG from '@plone/volto/icons/up-key.svg';
import downSVG from '@plone/volto/icons/down-key.svg';

const CollapsibleObjectWidget = ({ title, ...props }) => {
  const [open, setOpen] = useState(false);

  return (
    <Accordion fluid styled className="form">
      <Accordion.Title active={open} onClick={() => setOpen(!open)}>
        {title}
        <Icon name={open ? upSVG : downSVG} size="20px" />
      </Accordion.Title>
      <Accordion.Content active={open}>
        <AnimateHeight animateOpacity duration={500} height={open ? 'auto' : 0}>
          <Segment className="attached">
            <ObjectWidget {...props} />
          </Segment>
        </AnimateHeight>
      </Accordion.Content>
    </Accordion>
  );
};

export default CollapsibleObjectWidget;
